'use client';

import { ButtonWithIcon, ButtonWithIconProps } from '../button-with-icon';
import { useFormContext as useFormContextInternal } from './formContext';
import { useFormContext } from 'react-hook-form';

export const SubmitButton = ({
  disabled,
  shouldValidate = true,
  ...rest
}: ButtonWithIconProps & { shouldValidate?: boolean }) => {
  const { isLoading, readOnly } = useFormContextInternal();
  const { formState } = useFormContext();

  const isFormInvalid = shouldValidate && !formState.isValid;
  const shouldDisableButton = disabled || isFormInvalid || isLoading || readOnly;

  return <ButtonWithIcon {...rest} type="submit" disabled={shouldDisableButton} isLoading={isLoading} />;
};
